import PgaCoachSearchMap from './pga-coach-search-map'

export default PgaCoachSearchMap
